export var isValueNotPresentInOptions = function isValueNotPresentInOptions(value, options) {
  var optionsValueKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  return value && options && options.length > 0 && !options.find(function (item) {
    return value === item[optionsValueKey];
  });
};